const API_PATH_PREFIX = "/api/v1";
const configuredApiBaseUrl = import.meta.env.VITE_API_URL?.trim() ?? "";

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, "");
}

export function getApiBaseUrl() {
  return configuredApiBaseUrl
    ? trimTrailingSlash(configuredApiBaseUrl)
    : API_PATH_PREFIX;
}

export function apiUrl(path: string) {
  if (!configuredApiBaseUrl) {
    return path;
  }

  const base = trimTrailingSlash(configuredApiBaseUrl);
  const normalizedPath = path.startsWith(API_PATH_PREFIX)
    ? path.slice(API_PATH_PREFIX.length)
    : path;

  return `${base}${normalizedPath || ""}`;
}
